import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../services/api";
import { API_ENDPOINTS } from "../constants/actionTypes";

// Thunk for fetching ALL user action logs
export const fetchAllUserActionLogs = createAsyncThunk(
  "userActionLog/fetchAll",
  async ({ pageNumber = 1, pageSize = 100 } = {}, { rejectWithValue }) => {
    try {
      const params = { pageNumber, pageSize };

      const response = await axiosInstance.get(
        API_ENDPOINTS.USER_ACTION_LOG.SELECT_ALL,
        { params },
      );

      return response.data;
    } catch (error) {
      console.error(
        "❌ User Action Logs API Error:",
        error.response?.status,
        error.response?.data,
      );
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch user action logs",
      );
    }
  },
);

// Thunk for fetching user action log by ID
export const fetchUserActionLogById = createAsyncThunk(
  "userActionLog/fetchById",
  async (logId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.USER_ACTION_LOG.SELECT}/${logId}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "User Action Log not found",
      );
    }
  },
);

const userActionLogSlice = createSlice({
  name: "userActionLog",
  initialState: {
    logsList: [], // Flat array for table
    pagination: null, // Full pagination wrapper
    selectedLog: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearSelectedLog: (state) => {
      state.selectedLog = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch All Logs
      .addCase(fetchAllUserActionLogs.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAllUserActionLogs.fulfilled, (state, action) => {
        state.isLoading = false;
        const apiData = action.payload?.data;
        state.logsList = apiData?.data || apiData || [];
        state.pagination = apiData;
      })
      .addCase(fetchAllUserActionLogs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to fetch user action logs";
        console.error("❌ User Action Logs API Failed:", action.payload);
      })
      // Fetch By ID
      .addCase(fetchUserActionLogById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchUserActionLogById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.selectedLog = action.payload.data;
      })
      .addCase(fetchUserActionLogById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSelectedLog } = userActionLogSlice.actions;
export default userActionLogSlice.reducer;
